import React, { Component } from "react";
import { qpFormWizard } from "../../utils/misc";
import '../Home/Home.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/CreditabilityStore';
import { ClipLoader } from 'react-spinners';
import { css } from 'emotion';
import CompanyForm from './CompanyForm';
import ContactForm from './ContactForm';
import BankReferenceForm from './BankReference';
import TradeReferenceForm from './TradeReference';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;


const LastPage = () => {
    return (
        <div className="text-center">
            <h6 className="my-5">Thank you for application</h6>
            <i className="batch-icon batch-icon-clipboard-alt batch-icon-xxl"></i>
            <p className="display-4 mt-3">Your Application recieved by team</p>
            <p>After investigation of your application, We will keep in touch shortly</p>
            <a href="https://dev-minayla.azurewebsites/DLogin" className="btn btn-secondary">
                Go To Login
         </a>
        </div>
    );
}


class Creditability extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CompanyTitle: '',
            CreditApplicationId: 0,
            ReferenceCode: '',
            BusinessType: '',
            BusinessDate: '',
            OperationType: '',
            OtherCompanyName: '',
            OtherBusinessDate: '',
            loading: false,
            page: 1,
            progress : 20,
            ContactTitle: 'mr',
            formData: [{ InstitutionName: '', CheckingAccountNumber: '', Address: '', Phone: '' }],
            TradeRefData: [{ TradeCompanyName: '', TradeContactName: '', TradeAddress: '', TradePhoneNumber: '', TradeAccountEstablishDate: 0, TradeCreditLimit: 0.0, TradeCurrentBalance: 0.0 }]
        }

    }

    handleChange(e, formData) {
        console.log("test", this.state);
        if (this.state.page === 3)
        {
            this.setState({ formData })
        }
        else if (this.state.page === 4) {
            this.setState({ TradeRefData: formData })
           
        }
        else {
            const { name, value } = e.target;
            this.setState({ [name]: value });
        }
        
    }
    nextPage = () => {
        if (this.state.page === 1) {
            this.saveCompany();
        }
        if (this.state.page === 2) {
            this.saveContact();
        }
        if (this.state.page === 3) {
            this.saveBankReferenceForm();
        }
        if (this.state.page === 4) {
            this.saveTradeReferenceForm();
        }
        this.setState({ page: this.state.page + 1, progress: this.state.progress + 20 })
    }

    previousPage = () => {
        this.setState({ page: this.state.page - 1, progress: this.state.progress - 20 })
    }
    saveContact() {
        this.setState({
            loading: true,
        })
        this.props.SaveContactInfo(this.state, this.props.creditForm.creditApplicationId).then(
            result => {
                console.log("rest comp info", result)
            },
            error => console.log("errorrrrrr saveUserProfile")
        );
    }
    saveCompany() {
        this.setState({
            loading: true,
        });
        this.props.SaveCompanyInfo(this.state, this.props.creditForm.creditApplicationId).then(
            result => {
                console.log("rest comp info", result)
            },
            error => console.log("errorrrrrr saveUserProfile")
        );
    }
    saveBankReferenceForm() {
        this.setState({
            loading: true,
        })
        this.props.saveBankRefInfo(this.state.formData, this.props.creditForm.creditApplicationId).then(
            result => {
                console.log("rest comp info", result)
            },
            error => console.log("errorrrrrr saveUserProfile")
        );
    }
    saveTradeReferenceForm() {
        this.setState({
            loading: true,
        })
        this.props.saveTradeRefForm(this.state.TradeRefData, this.props.creditForm.creditApplicationId).then(
            result => {
                console.log("rest comp info", result)
            },
            error => console.log("errorrrrrr saveUserProfile")
        );
    }
    componentDidMount() {
        if (this.props.location.search !== "") {
            const search = this.props.location.search;
            const params = new URLSearchParams(search);
            const ref = params.get('ref');
            this.setState({ ReferenceCode: ref })
            //this.loadData(ref);
            this.props.getCompanyForm(ref)

        }
    }

    //loadData(refCode){
    //    this.props.getCompanyForm(refCode)
    //    this.setState({ loading: this.props.isLoading })
    //    console.log("prop1",this.props.creditForm)
    //}
    render() {
        const { page } = this.state
        if (this.props.isLoading) {
            return <main className="main-content" role="main">
                <div className='sweet-loading' style={{ textAlign: 'center', marginTop: 250 }}>
                    <ClipLoader
                        className={override}
                        sizeUnit={"px"}
                        size={250}
                        color={'rgb(54, 215, 183)'}
                        loading={true}
                    />
                </div>
            </main>
        }

        return (
            <div>
                <nav className="navbar-sidebar-horizontal navbar navbar-expand-lg navbar-light bg-dark fixed-top" style={{ marginBottom: 50 }}>
                    <a className="navbar-brand" href={window.location.href} style={{ marginTop: "0", marginBottom: "0" }}>
                    <img
                        src="assets/img/minaylalogowhite.png"
                        width="91.5"
                        height="51.8"
                        alt="Minayla"
                    />
                </a>
            </nav>
            <main className="main-content p-5" role="main">
                <div className="row">
                    <div className="col-md-12">
                        <h1>Credit Application</h1>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-md-12 mb-4">
                        <div className="card" style={{
                            minHeight: '536px'
                        }}>
                            <div className="card-header">
                                Company Registration
                            <div className="progress">
                                    <div
                                        className="progress-bar progress-bar-sm bg-gradient"
                                        role="progressbar"
                                        aria-valuenow="0"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        style={{ width: this.state.progress + "%" }}
                                    />
                                </div>
                            </div>
                            <div className="card-form-wizard">
                                <ul className="nav nav-pills wizard-header" style={{ padding: '10px 15px' }}>
                                    <li><span className="main-text"><span class="h3">1. Company Information</span></span></li>
                                    <li><span className="main-text"><span className="h3">2. Contact Information</span></span></li>
                                    <li><span className="main-text"><span class="h3">3. Bank References</span></span></li>
                                    <li><span className="main-text"><span className="h3">4. Trade References</span></span></li>
                                    <li><span className="main-text"><span className="h3">5. Result</span></span></li>
                                </ul>
                                <div className="tab-content clearfix">
                                {page === 1 && <CompanyForm
                                    onChange={this.handleChange.bind(this)}
                                    onNextPage={() => this.nextPage()}
                                    creditabilityData={this.props.creditForm}
                                />}
                                {page === 2 && <ContactForm
                                    onChange={this.handleChange.bind(this)}
                                    onPreviousPage={() => this.previousPage()}
                                    onNextPage={() => this.nextPage()}
                                />}
                                {page === 3 && <BankReferenceForm
                                    onChange={this.handleChange.bind(this)}
                                    onPreviousPage={() => this.previousPage()}
                                    onNextPage={() => this.nextPage()}
                                    onFormData={this.state.formData}
                                />}
                                {page === 4 && <TradeReferenceForm
                                    onChange={this.handleChange.bind(this)}
                                    onPreviousPage={() => this.previousPage()}
                                    onNextPage={() => this.nextPage()}
                                    onFormData={this.state.TradeRefData}
                                />}
                                    {page === 5 && <LastPage />}
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                </main>
                </div>
        );
    }
}

export default connect(
    state => state.creditabilityData,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Creditability);



// WEBPACK FOOTER //
// ./src/view/Creditability/Creditability.js